export const ReviewBrewingMethods = {
  Aeropress: 'aeropress',
  PourOver: 'pour_over',
  SuperautomaticEspressoMachine: 'superautomatic_espresso_machine',
  EspressoMachine: 'espresso_machine',
  FrenchPress: 'french_press',
  Moccamaster: 'moccamaster',
  Drip: 'drip',
};
